import mutations from '@codehq/aurora-app-core/src/store/modules/auth/mutations';

export default mutations;
